<template lang="pug">
span
  span(@click="openModal")
    slot(name="activator")
  connect-transaction-desk(
    :value="openConnectModal"
    @open="openConnectModal = true"
    @close="onCloseConnectModal"
  )
  create-transaction-desk-transaction(
    :value="openCreateModal"
    @created="$emit('created-transaction')"
    @update-api-key="openConnectModal = true"
    @close="openCreateModal = false"
  )
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { INTEGRATION_STATUS, KEY_TD_INTEGRATION_STATUS,
  KEY_TD_CONNECTION_STATUS } from './constants';

const ConnectTransactionDesk = () =>
  import(/* webpackChunkName: 'ConnectTransactionDesk' */ './ConnectTransactionDesk');
const CreateTransactionDeskTransaction = () =>
  import(/* webpackChunkName: 'CreateTransactionDeskTransaction' */ './CreateTransactionDeskTransactionModal');

export default {
  name: 'TransactionDesk',
  components: {
    ConnectTransactionDesk,
    CreateTransactionDeskTransaction,
  },
  data() {
    return {
      openConnectModal: false,
      openCreateModal: false,
    };
  },
  async created() {
    await this.getIntegrationStatus();
    localStorage.removeItem(KEY_TD_INTEGRATION_STATUS);
    localStorage.removeItem(KEY_TD_CONNECTION_STATUS);
  },
  computed: {
    ...mapState('transactionDesk', ['integrationStatus']),
    ...mapGetters('userInformation', ['userHasFeatureFlag']),
  },
  methods: {
    ...mapActions('transactionDesk', ['getIntegrationStatus']),
    openModal() {
      if (this.isIntegrationDisconnected()) {
        this.openConnectModal = true;
      } else {
        this.openCreateModal = true;
      }
    },
    isIntegrationDisconnected() {
      return (localStorage.getItem(KEY_TD_INTEGRATION_STATUS) || this.integrationStatus) === INTEGRATION_STATUS.DISCONNECTED;
    },
    onCloseConnectModal(openCreateTransaction) {
      this.openConnectModal = false;
      this.openCreateModal = openCreateTransaction;
    },
  },
}
</script>
